var _path, _rect, _ellipse, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07837 8.48474C6.28318 8.48474 5.63855 9.12937 5.63855 9.92457C5.63855 10.7198 6.28318 11.3644 7.07837 11.3644H15.0421C15.8373 11.3644 16.4819 10.7198 16.4819 9.92457C16.4819 9.12937 15.8373 8.48474 15.0421 8.48474H7.07837ZM7.07837 13.3332C6.28318 13.3332 5.63855 13.9779 5.63855 14.7731C5.63855 15.5682 6.28318 16.2129 7.07837 16.2129H15.0421C15.8373 16.2129 16.4819 15.5682 16.4819 14.7731C16.4819 13.9779 15.8373 13.3332 15.0421 13.3332H7.07837Z",
    fill: "#5F738C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.35846,
    y: 4.3562,
    width: 9.40355,
    height: 1.43982,
    rx: 0.719912,
    fill: "#5F738C",
    stroke: "#5F738C",
    strokeWidth: 1.43982
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.03613,
    cy: 5.08207,
    rx: 1.3012,
    ry: 1.44578,
    fill: "#5F738C"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.03613,
    cy: 9.93062,
    rx: 1.3012,
    ry: 1.44578,
    fill: "#5F738C"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.03613,
    cy: 14.7791,
    rx: 1.3012,
    ry: 1.44578,
    fill: "#5F738C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.07cac69669bd33c970e06ba1a4e7b184.svg";
export { ForwardRef as ReactComponent };